import React, { useEffect } from 'react';

const GoogleReviewsWidget = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://widgets.sociablekit.com/google-reviews/widget.js';
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      style={{
        background: 'linear-gradient(180deg, #000b3e 0%, #020202 59%)',
        padding: '40px 20px',
        color: '#fff',
      }}
    >
      <h2 style={{ textAlign: 'center', marginBottom: '30px', fontSize: '30px' }}>
        Google Reviews
      </h2>
      <div
        className='sk-ww-google-reviews'
        data-embed-id='25583184'
        style={{ maxWidth: '1000px', margin: '0 auto' }}
      ></div>
    </div>
  );
};

export default GoogleReviewsWidget;
